var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconNdqFinalTrophy = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 39.651"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-ndq-final-trophy_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 159741",
  fill: "none",
  d: "M0 0h24v39.651H0z"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27653",
  clipPath: "url(#icon-ndq-final-trophy_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36627",
  d: "M15.722 27.029H6.43a.593.593 0 00-.593.593v2.625h10.667v-2.63c-.072-.472-.783-.588-.783-.588",
  fill: "#d6eff4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36628",
  d: "M13.3 22.393a2.979 2.979 0 01.279-1.711 1.824 1.824 0 01.92-.946l-.6-1.087h-3.754l-.365.659-.237.428a1.821 1.821 0 01.961 1.032 2.608 2.608 0 01.154.428 6.737 6.737 0 011.368-.752c.285.022.871.89.871.89s.152 4.213.217 4.8c.022.195-.8.537-1.982.9l4.7.014c-1.761-1.008-2.348-3.074-2.528-4.658",
  fill: "#ed8e06"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36629",
  d: "M13.114 26.133c-.065-.586-.217-4.8-.217-4.8s-.586-.869-.871-.89a6.734 6.734 0 00-1.368.752 3.162 3.162 0 01.075 1.206c-.193 1.58-.8 3.633-2.557 4.626h.223l2.733.008c1.177-.367 2-.71 1.982-.9",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36630",
  d: "M17.569 27.029h-1.847s.711.116.783.588v1.244l-10.667.625h10.667v.763h1.656v-2.628a.593.593 0 00-.593-.593",
  fill: "#85abb3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36631",
  d: "M3.603 29.484a.933.933 0 00-.933.933v7.337h4.266l6-8.27z",
  fill: "#d6eff4"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36632",
  d: "M18.381 29.484h-5.448l-6 8.27h4.916l6.969-.759a1.046 1.046 0 00.933-1.04v-6.019c-.236-.344-1.374-.452-1.374-.452",
  fill: "#aee0ea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36633",
  d: "M20.397 29.484h-2.016s1.138.109 1.374.452v6.019a1.046 1.046 0 01-.933 1.04l-6.969.759h9.476v-7.337a.932.932 0 00-.933-.932",
  fill: "#85abb3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36634",
  d: "M11.999-.003a.291.291 0 00-.264.165L8.206 7.379l3.793 5.194z",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36635",
  d: "M12 19.056l7.1 3.764a.29.29 0 00.349-.058l-7.445-10.189z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36636",
  d: "M4.903 22.82l7.1-3.764v-6.445L4.608 22.805a.289.289 0 00.3.015",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36637",
  d: "M12.264.165A.291.291 0 0012-.003v12.576l.014.019 3.779-5.21z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36638",
  d: "M8.207 7.382L.253 8.508a.29.29 0 00-.237.2L12 12.59v-.014z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36639",
  d: "M19.445 22.762a.287.287 0 00.079-.253l-1.387-7.913-6.123-2z",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36640",
  d: "M4.476 22.509a.29.29 0 00.129.3L12 12.615v-.009l-6.137 2z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36641",
  d: "M.016 8.705a.29.29 0 00.074.305l5.773 5.586 6.137-2v-.014z",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36642",
  d: "M23.984 8.705a.29.29 0 00-.237-.2l-7.954-1.126-3.779 5.21h.008z",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36643",
  d: "M23.984 8.705l-11.962 3.889 6.115 2 5.773-5.586a.29.29 0 00.074-.305",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36644",
  d: "M12 .802c.076 1.965.11 3.931.142 5.9l.026 2.948c0 .983.021 1.965.014 2.948v.223l-.209-.07c-1.656-.552-3.32-1.083-4.97-1.652s-3.3-1.131-4.945-1.729c1.68.478 3.352.984 5.02 1.5s3.33 1.052 5 1.576l-.211.153c-.01-.983 0-1.965 0-2.948l.015-2.948c.025-1.965.052-3.931.12-5.9",
  fill: "#ffe36c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36645",
  d: "M5.08 22.124c1.1-1.631 2.231-3.238 3.365-4.844l1.719-2.4c.577-.8 1.143-1.6 1.728-2.389l.133-.179.128.18c1.011 1.423 2.041 2.833 3.038 4.267s2 2.863 2.972 4.315c-1.075-1.377-2.125-2.773-3.168-4.173s-2.067-2.814-3.1-4.22h.26c-.572.8-1.162 1.585-1.743 2.378L8.66 17.43a265.942 265.942 0 01-3.577 4.689",
  fill: "#ffe36c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36646",
  d: "M18.964 22.126a252.148 252.148 0 01-3.577-4.689l-1.752-2.371c-.58-.793-1.171-1.579-1.743-2.378l-.13-.181.21-.066c1.665-.526 3.323-1.073 4.993-1.581s3.338-1.025 5.018-1.5c-1.641.6-3.291 1.171-4.944 1.735s-3.313 1.1-4.969 1.657l.08-.248c.585.79 1.152 1.593 1.728 2.388l1.719 2.4a269.554 269.554 0 013.365 4.843",
  fill: "#ffe36c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36647",
  d: "M21.976 37.792a.681.681 0 01.029.186v.523a.687.687 0 01-.687.687H1.799a.679.679 0 01-.217-.038.685.685 0 00.659.5h19.518a.687.687 0 00.688-.687v-.523a.685.685 0 00-.47-.649",
  fill: "#85abb3"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36648",
  d: "M21.318 39.188a.687.687 0 00.688-.687v-.523a.176.176 0 00-.246-.224H2.241a.688.688 0 00-.687.688v.523a.176.176 0 00.246.224z",
  fill: "#aee0ea"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36649",
  d: "M8.122 34.007a.4.4 0 010-.8h2.114l1.134-1.564H6.901a.49.49 0 00-.49.49v2.977a.49.49 0 00.49.49h1.6l1.153-1.59z",
  fill: "#f9f9f9"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36650",
  d: "M17.097 31.64h-5.73l-1.134 1.564h5.644a.4.4 0 010 .8H9.651l-1.153 1.59h8.6a.49.49 0 00.49-.49v-2.977a.49.49 0 00-.49-.49",
  fill: "#ededed"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36651",
  d: "M7.72 33.606a.4.4 0 00.4.4h1.532l.582-.8H8.12a.4.4 0 00-.4.4",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36652",
  d: "M15.879 34.008a.4.4 0 100-.8h-5.644l-.582.8z",
  fill: "#f59c0f"
}))));
export default __webpack_public_path__ + "static/icon-ndq-final-trophy.6688c815f6c7803187ae06a94b5c59ac.svg";
export { SvgIconNdqFinalTrophy as ReactComponent };